import React from "react";

import { PropTypeShapes } from "../../types";

const ModalDescription = props => (
  <div className="modalDescription" style={{ flexGrow: 1 }}>
    {props.children}
  </div>
);

ModalDescription.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired
};

export default ModalDescription;
